<ng-container *transloco="let t; prefix: scope">
  <div class="grid grid-cols-5 gap-2">
    <bl-frontend-text-input
      [text]="t('contact')"
      [(ngModel)]="contactModel.label"
      [maxlength]="100"></bl-frontend-text-input>

    <bl-frontend-text-input
      [text]="t('phone')"
      [(ngModel)]="contactModel.phone"
      [maxlength]="50"></bl-frontend-text-input>

    <bl-frontend-text-input
      [text]="t('email')"
      [(ngModel)]="contactModel.email"
      [maxlength]="50"></bl-frontend-text-input>

    <bl-frontend-text-input
      [text]="t('comments')"
      [(ngModel)]="contactModel.comment"
      [maxlength]="50"></bl-frontend-text-input>
    <div class="mb-2 gap-2 flex items-end">
      <bl-frontend-button
        variant="secondary"
        (onclick)="unSelect()"
        [text]="'shared.reset' | transloco"></bl-frontend-button>
      <bl-frontend-button
        (click)="saveContact()"
        [disabled]="client.archived || client.id === -1 || !isContactFormValid || savingState()"
        [text]="'shared.save' | transloco">
      </bl-frontend-button>
    </div>
  </div>
  <br />
  <br />
  <app-table
    [columns]="columns$ | async"
    [data]="client.contacts"
    sortField="label"
    [columnSelector]="false"
    (rowClick)="onRowSelect($event)"
    rowClass="cursor-pointer"
    [paginator]="false"
    [useFixedStyle]="true">
    <ng-template tableTemplate="bodyCell" tableBodyCellField="action" let-rowData="rowData">
      <span
        (click)="deleteContact(rowData.id)"
        class="far fa-trash-alt cursor-pointer"
        style="text-align: center"
        [title]="t('deleteContact')">
      </span>
    </ng-template>

    <ng-template tableTemplate="emptyMessage">{{ t('noContactsToShow') }}</ng-template>
  </app-table>
</ng-container>
